import { PartnerTabsNav, type PartnerTabItem } from './PartnerTabsNav';

/** The pages of the "Sales" nav group, in the order the side menu lists them. */
export const PARTNER_SALES_TABS: PartnerTabItem[] = [
  { value: 'leads', labelKey: 'partner.leads.title', to: '/partner/leads' },
  { value: 'contacts', labelKey: 'partner.contacts.title', to: '/partner/contacts' },
  { value: 'calculator', labelKey: 'partner.calculator.title', to: '/partner/calculator' },
  { value: 'info-hub', labelKey: 'partner.infoHub.title', to: '/partner/info-hub' },
  { value: 'program', labelKey: 'partner.program.title', to: '/partner/program' }
];

export function PartnerSalesTabsNav() {
  return <PartnerTabsNav tabs={PARTNER_SALES_TABS} />;
}
